import { common } from "./common";
import { nav } from "./nav";
import { dashboard } from "./dashboard";
import { guide } from "./guide";
import { onboarding } from "./onboarding";
import { reviewPrompt } from "./reviewPrompt";
import { quoteDetail } from "./quoteDetail";
import { quotes } from "./quotes";
import { quoteNew } from "./quoteNew";
import { quoteMisc } from "./quoteMisc";
import { companies } from "./companies";
import { priceLists } from "./priceLists";
import { poImports } from "./poImports";
import { ai } from "./ai";
import { settings } from "./settings";
import { feedback } from "./feedback";

// NOTE: intentionally NO `as const` here — a top-level `as const` would pin
// every value to its English literal type and make the Italian dictionary
// (which must satisfy `typeof en`) fail to type-check. Key-shape parity is
// still enforced: `it` is declared `: typeof en`, so tsc fails if any
// namespace is missing/extra a key.
export const en = {
  common,
  nav,
  dashboard,
  guide,
  onboarding,
  reviewPrompt,
  quoteDetail,
  quotes,
  quoteNew,
  quoteMisc,
  companies,
  priceLists,
  poImports,
  ai,
  settings,
  feedback,
};
